var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1475_230)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 56.2987,
    fill: "url(#paint0_linear_1475_230)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 56.2987,
    fill: "url(#paint1_linear_1475_230)",
    fillOpacity: 0.1,
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.404 142.32L145.833 77L193.001 179.757L170.869 179.562L145.703 121.831C145.129 120.34 144.157 119.035 142.892 118.059C141.309 116.803 139.357 116.102 137.336 116.066C131.6 115.926 128.596 123.571 129.138 122.416C118.97 144.092 130.714 120.752 121.732 138.795C121.736 138.804 116.404 142.32 116.404 142.32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 179.367L109.777 77L156.943 179.757L134.398 179.562L109.646 125.551C109.072 124.06 108.1 122.755 106.835 121.778C105.252 120.522 103.3 119.822 101.279 119.786C95.5433 119.646 92.5389 127.291 93.0807 126.136C82.913 147.812 77.3108 161.519 68.3281 179.562C68.3318 179.572 63 179.367 63 179.367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.474 134.21L101.887 164.899C100.254 167.735 97.9015 170.09 95.0667 171.724C90.7814 174.095 84.737 174.649 84.737 174.649H65.8701L63 179.562H86.3882C86.3882 179.562 93.2398 179.066 97.6926 176.247C100.534 174.368 102.875 171.825 104.512 168.838L118.71 138.928L116.474 134.21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1475_230",
    x: -2.04722,
    y: -2.04722,
    width: 260.094,
    height: 260.094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.04722,
    dy: 2.04722
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.02361
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1475_230"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.04722,
    dy: -2.04722
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.02361
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1475_230",
    result: "effect2_innerShadow_1475_230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1475_230",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46BD84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1475_230",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentApp);
export default __webpack_public_path__ + "static/media/student-app.3c68e8ff7892e482a5af37e2b8f028cf.svg";
export { ForwardRef as ReactComponent };